import { render, staticRenderFns } from "./DropdownSelection.vue?vue&type=template&id=2122984d&scoped=true&"
import script from "./DropdownSelection.vue?vue&type=script&lang=js&"
export * from "./DropdownSelection.vue?vue&type=script&lang=js&"
import style0 from "./DropdownSelection.vue?vue&type=style&index=0&id=2122984d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2122984d",
  null
  
)

export default component.exports